import { useSyncExternalStore } from "react"

import { hasObtrusiveScrollbars } from "@/lib/has-obtrusive-scrollbars"

const subscribe = () => () => undefined
const getServerSnapshot = () => true

/**
 * Overlay vs classic scrollbars is static for the lifetime of a page. The
 * server snapshot assumes classic scrollbars so SSR matches the custom
 * ScrollArea; the client snapshot refreshes after hydration.
 */
export function useHasObtrusiveScrollbars(): boolean {
  return useSyncExternalStore(
    subscribe,
    hasObtrusiveScrollbars,
    getServerSnapshot
  )
}
